<template>
  <div class="personal-data-component">
    <div class="resetPassword-wrap">
      <div class="title">修改手机号</div>
      <div class="reset-form">
        <div class="login-msg">
          <div class="phone-inp">
            <div class="icon flex-cc">
              <img src="~@/assets/images/login_phone_icon.png" alt="">
            </div>
            <input type="text" name="oldPhone" readonly placeholder="请输入旧手机号" id="phone" v-model="form.oldPhone">
          </div>
          <div class="new-pwd-inp">
            <div class="icon flex-cc">
              <img src="~@/assets/images/login_pwd_icon1.png" alt="">
            </div>
            <input type="password" name="" placeholder="请输入登录密码" id="newPwd" v-model="form.password">
          </div>
          <div class="phone-inp">
            <div class="icon flex-cc">
              <img src="~@/assets/images/login_phone_icon.png" alt="">
            </div>
            <input type="text" name="phone" placeholder="请输入新手机号" id="phone" v-model="form.phone">
          </div>
          <div class="code-inp">
            <div class="icon flex-cc">
              <img src="~@/assets/images/login_msg_icon.png" alt="">
            </div>
            <input type="text" name="code" placeholder="请输入短信验证码" id="code" v-model="form.code">
            <div class="send-code-btn flex-cc">
              获取验证码
            </div>
          </div>
          <div class="btn-list">
            <el-button class="submit flex-cc" :loading="loading" @click="handleSubmit">确认</el-button>
            <el-button class="cancel flex-cc" @click="goBack">取消</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 滑动验证码 -->
    <Verify ref="verify" @success="captchaSuccess" mode="pop" :captchaType="form.captchaType"
      :imgSize="{ width: '330px', height: '155px' }"></Verify>
  </div>
</template>

<script>
import { sendCode } from "@/api/common";
import { getInfo, setPhone } from "@/api/user";
import { validatePhone } from "@/utils/validate";
import waves from '@/directive/waves' // 水波纹指令
//引入组件
import Verify from "@/components/verifition/Verify";
export default {
  name: 'UserPhone',
  components: {
    Verify
  },
  data() {
    return {
      loading: true,
      form: {
        oldPhone: '',
        phone: '',
        code: '',
        password: '',
        captchaType: "blockPuzzle",
        captchaVerification: "",
      },
      disabled: false,
      countdown: 60,
      text: "发送验证码",
    };
  },
  computed: {

  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      getInfo(this.form).then(res => {
        this.loading = false;
        this.form.oldPhone = res.data.phone
      }).catch((err) => {

      });
    },
    sendCode() {
      const that = this
      const _form = that.form;
      if (that.disabled) return
      console.log(_form)
      if (!_form.phone) {
        this.$message({
          type: 'error',
          message: '请输入手机号'
        });
        return;
      }
      if (!validatePhone(_form.phone)) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号码'
        });
        return;
      }
      if (!_form.captchaVerification) {
        this.$refs.verify.show()
        return;
      }
      that.disabled = true
      sendCode(that.form).then((res) => {
        that.timer = setInterval(() => {
          that.countdown--
          this.text = "重新发送(" + that.countdown + "s)"
          if (that.countdown == 0) {
            that.disabled = false
            that.text = '发送验证码'
            that.countdown = 60
            clearInterval(that.timer)
          }
        }, 1000)

        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '短信发送成功'
          });
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          });
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    captchaSuccess(params) {
      console.log(params);
      this.form = {
        ...this.form,
        ...params,
      }
      this.sendCode()
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
    },
    // 提交订单
    handleSubmit() {
      const _form = this.form;
      if (!_form.phone) {
        this.$message({
          type: 'error',
          message: '请输入手机号'
        });
        return;
      }
      if (!validatePhone(_form.phone)) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号码'
        });
        return;
      }
      if (!_form.password) {
        this.$message({
          type: 'error',
          message: '请输入密码'
        });
        return;
      }
      if (!_form.code) {
        this.$message({
          type: 'error',
          message: '请输入验证码'
        });
        return;
      }
      if (!_form.captchaVerification) {
        this.$refs.verify.show()
        return;
      }
      this.loading = true;
      setPhone(_form)
        .then((response) => {
          this.loading = false;
          // 弹出操作提示
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
          this.goBack();
        })
        .catch(() => {
          this.loading = false;
        });

    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/profile.less';
</style>
